import { render, staticRenderFns } from "./square-column-num.mpx?vue&type=template&id=d1a22140&isComponent&outputPath=components%2Fsquare-column-num0fe8f248%2Findex"
import script from "./square-column-num.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsquare-column-num0fe8f248%2Findex"
export * from "./square-column-num.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsquare-column-num0fe8f248%2Findex"
import style0 from "./square-column-num.mpx?vue&type=style&index=0&id=d1a22140&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_0fe8f248%22%7D&isComponent&outputPath=components%2Fsquare-column-num0fe8f248%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports